import { render, staticRenderFns } from "./CompareLeaders.vue?vue&type=template&id=c572b526&scoped=true"
import script from "./CompareLeaders.vue?vue&type=script&lang=js"
export * from "./CompareLeaders.vue?vue&type=script&lang=js"
import style0 from "./CompareLeaders.vue?vue&type=style&index=0&id=c572b526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c572b526",
  null
  
)

export default component.exports